import { call, put, select, takeLatest } from 'redux-saga/effects';
import filter from 'lodash/filter';
import * as actions from './actions';
import * as api from '../../api';
import { searchByText } from '../../helpers/utils';

export function* getDefaultCourses(productId) {
    yield put(actions.resetSearchFilter());
    const payload = yield call(api.getDefaultCourses, productId);
    if (payload.status === 200) {
        const courses = payload.data.map((item) => {
            const yearGroups = [];
            item.yearGroups.forEach((yearGroup) => {
                yearGroups.push(yearGroup.yearGroupEnum);
            });
            item.yearGroupCombined = yearGroups.join(', ');
            item.yearGroupList = yearGroups;
            return item;
        });
        yield put(actions.getDefaultCoursesSuccess(courses));
        yield put(actions.filterDefaultCourses());
    } else {
        yield put(actions.getDefaultCoursesFailure());
    }
}

export function* getDefaultCoursesSaga() {
    yield takeLatest(actions.GET_DEFAULT_COURSES_REQUEST, getDefaultCourses);
}

export function* applySearchFilter({ label, value }) {
    const { defaultCourse } = yield select();
    defaultCourse.filters[label] = value;
    yield put(actions.filterDefaultCourses());
}

export function* applySearchFilterSaga() {
    yield takeLatest(actions.APPLY_SEARCH_FILTER, applySearchFilter);
}

export function* filterDefaultCourses() {
    const { defaultCourse } = yield select();
    const { filters, courses } = defaultCourse;
    const { search, country, year, status } = filters;
    let results = searchByText(courses, search);

    if (country !== '') {
        results = filter(results, { country });
    }
    if (year) {
        results = filter(results, item => item.yearGroupList.indexOf(parseInt(year, 10)) !== -1);
    }
    if (status) {
        results = filter(results, item => item.status === status);
    }
    yield put(actions.filterDefaultCoursesSuccess(results));
}

export function* filterDefaultCoursesSaga() {
    yield takeLatest(actions.FILTER_DEFAULT_COURSES, filterDefaultCourses);
}


export function* archiveSelectedCourse({ productId, courseId, courseVersion }) {
    const payload = yield call(api.archiveSelectedCourse, productId, courseId, courseVersion);
    if (payload.status === 200) {
        yield put(actions.archiveSelectedCourseSuccess(productId));
    } else {
        yield put(actions.archiveSelectedCourseFailure());
    }
}

export function* archiveSelectedCourseSaga() {
    yield takeLatest(actions.ARCHIVE_SELECTED_COURSE_REQUEST, archiveSelectedCourse);
}



// WEBPACK FOOTER //
// ./app/containers/default-courses/saga.js